export const resolveCrmMode = (placementEnabled, homeCareEnabled) => {
    if (placementEnabled && homeCareEnabled)
        return "combined";
    if (placementEnabled)
        return "placement-only";
    if (homeCareEnabled)
        return "home-care-only";
    return "none";
};
//# sourceMappingURL=crm-mode.js.map